import { PublicClientApplication, type IPublicClientApplication } from '@azure/msal-browser';
import { getPluginsStatus } from '@cdf/api-client-react';

import {
  configureExternalAuth,
  configureWorkforceAuth,
  entraEnabled,
  getAuthProviderConfig,
  resolveInitialAuthProvider,
  type AuthProviderKind
} from './auth-config';

export async function prepareBrowserAuth(): Promise<{
  instance: IPublicClientApplication | null;
  provider: AuthProviderKind;
}> {
  // Load before deciding whether sign-in is enabled. Static builds must never
  // mistake missing build-time settings for an explicitly disabled provider.
  const plugins = await getPluginsStatus({
    cache: 'no-store',
    signal: AbortSignal.timeout(15_000)
  });
  configureWorkforceAuth(plugins.auth);
  if (!entraEnabled) return { instance: null, provider: 'workforce' };
  configureExternalAuth(plugins.auth.external);

  const provider = resolveInitialAuthProvider();
  const config = getAuthProviderConfig(provider);
  if (!config) throw new Error('Selected identity provider configuration is incomplete.');

  const instance = new PublicClientApplication(config.msalConfig);
  // MSAL v5 synchronizes account changes across same-origin tabs itself.
  await instance.initialize();
  return { instance, provider };
}
